import React from 'react'
import {
  fbLogoutPopup,
  logoutFb,
  facebookProfile
} from '../../action/action'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { logout } from '../shared/facebookOauth'
import { logoutM } from '../shared/facebookOauthMobile'
import { popupColorSet } from '../../JS/setColors'
import $ from 'jquery'

class LogoutPopup extends React.Component {

  onNoClick = () => {
    this.props.fbLogoutPopup(false);
  }
  onYesClick = () => {
    this.props.fbLogoutPopup(false);
    this.onLogoutClick();
  }
  componentDidMount() {
    popupColorSet(this.props.menuColor);
  }
  onLogoutClick = (index) => {
    // this.props.fbLogoutPopup(true);
    let userData = localStorage.getItem("FB_user_info");
    //this.setState({ currentActive: index });
    if (window.cordova) {
      console.log("mobile before logout", userData);
      logoutM();
      console.log('after logout', userData);
    } else {
      console.log("before logout", userData);
      logout();
      userData = localStorage.getItem("FB_user_info");
      console.log('after logout', userData);
    }
    this.props.logoutFb(!this.props.fbStatus);
    this.props.facebookProfile(null);
  }
  render() {
    let userData = localStorage.getItem("FB_user_info");
    return (
      <div className="overlay">
        <div id="svc" className="overlay-body">
          <div className="overlay-close" onClick={this.onNoClick}>
            <i className="fa fa-close"></i>
          </div>
          {userData && userData !== "null" ?
            <div className="primary-response center">
              <div className="wide" style={{ fontSize: '20px', color: "inherit" }}>
                are you sure you want to logout from facebook.
            </div>
              <button className="btn-yes" onClick={this.onYesClick} style={{ border: "none", color: "inherit" }}>
                {this.props.stringConst.yes}
              </button>
              <button className="btn-no" onClick={this.onNoClick} style={{ border: "none", color: "inherit" }}>
                {this.props.stringConst.no}
              </button>
            </div>
            : <div className="response" style={{ color: "inherit" }}>
              You are not logged in to facebook to log you out.
            </div>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    menuColor: state.store.home.MenuColor
  }
}

LogoutPopup.propTypes = {
  roomAssistancePageStatus: PropTypes.bool,
  stringConst: PropTypes.object,
}

export default connect(
  mapStateToProps,
  {
    fbLogoutPopup,
    logoutFb,
    facebookProfile
  }
)(LogoutPopup);